export enum NotificationType {
    Any = 0,
    InApp = 1 << 0,
    Email = 1 << 1,
    Text = 1 << 2
}